import { render, staticRenderFns } from "./SeminarInformation.vue?vue&type=template&id=2b77fa7a&scoped=true&lang=pug&"
import script from "./SeminarInformation.vue?vue&type=script&lang=ts&"
export * from "./SeminarInformation.vue?vue&type=script&lang=ts&"
import style0 from "./SeminarInformation.vue?vue&type=style&index=0&id=2b77fa7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b77fa7a",
  null
  
)

export default component.exports